/**
 * AppConstants contains any application-wide constants
 */
export class AppConstants {
  static readonly KEY_TOKEN = "token";
  static readonly USERNAME = "username";

  static readonly MENU_APPLICATIONS = "applications";
  static readonly MENU_SUPPLIERS = "suppliers";
  static readonly MENU_TRANSACTIONS = "transactions";
  static readonly MENU_CREDIT_PLANS = "credit-plans";
  static readonly MENU_LOGIN = "login";
  static readonly MENU_ROOT = "";
  static readonly MENU_HOME = "home";
  static readonly MENU_USERS = "users";
  static readonly MENU_BEYOND_SUPPLIERS = "beyond-suppliers";
  static readonly MENU_TERMINATIONS = "terminations";
  static readonly MENU_MANUAL_REVIEW = "manual-review";

  static API_FETCH_INTERVAL = 1000 * 60;
}
